import { useEffect, useRef, useState } from "react"
import PDFViewer from "@common/components/PDFViewer"
import styled from "styled-components/macro"
import { Document, Page } from "react-pdf"

const pdfs = [
  {
    path: "/assets/pdfs/brochure.pdf",
    title: "Brochure",
  },
  {
    path: "/assets/pdfs/dataloft-report.pdf",
    title: "Dataloft Report",
  },
  {
    path: "/assets/pdfs/factsheet-english.pdf",
    title: "Factsheet English",
  },
  {
    path: "/assets/pdfs/factsheet-mandarin.pdf",
    title: "Factsheet Mandarin",
  },
  {
    path: "/assets/pdfs/factsheet-turkish.pdf",
    title: "Factsheet Turkish",
  },
  {
    path: "/assets/pdfs/factsheet-arabic.pdf",
    title: "Factsheet Arabic",
  },
]

export default function InfoDevelopment() {
  const [selectedPdf, setSelectedPdf] = useState(null)

  if (selectedPdf) {
    return (
      <Wrapper>
        <PDFViewer
          pfdFile={selectedPdf.path}
          pageDisplay="single"
          title={selectedPdf.title}
          setSelectedPdf={setSelectedPdf}
        />
      </Wrapper>
    )
  }

  return (
    <GridContainer>
      {pdfs.map((pdf) => (
        <PDFCard key={pdf.path} onClick={() => setSelectedPdf(pdf)}>
          <PDFThumbnailPreview pdfPath={pdf.path} />
          <PDFTitle>{pdf.title}</PDFTitle>
        </PDFCard>
      ))}
    </GridContainer>
  )
}

const PDFIcon = () => (
  <svg
    width="64"
    height="64"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    style={{ color: "#666" }}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    />
  </svg>
)

const PDFThumbnailPreview = ({ pdfPath }) => {
  const [height, setHeight] = useState(0)
  const thumbnailRef = useRef(null)

  useEffect(() => {
    if (thumbnailRef.current) {
      const width = thumbnailRef.current.clientWidth
      setHeight((width * 4) / 3)
    }
  }, [])

  return (
    <PDFThumbnail ref={thumbnailRef}>
      <Document file={pdfPath} loading={<PDFIcon />} error={<PDFIcon />}>
        <Page
          pageNumber={1}
          height={height}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      </Document>
    </PDFThumbnail>
  )
}

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
`

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 2rem;
  padding: 2rem;
`

const PDFCard = styled.div`
  cursor: pointer;
  padding: 1rem;
  background-color: var(--primary);
  border-radius: 10px;
  opacity: 0.8;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    opacity: 1;
  }
`

const PDFThumbnail = styled.div`
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  height: auto;
  aspect-ratio: 16/9;
  overflow: hidden;

  .react-pdf__Page__canvas {
    max-width: 100%;
    height: auto !important;
    width: auto !important;
  }

  .react-pdf__Document {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

const PDFTitle = styled.h3`
  text-align: center;
  font-weight: 500;
`
